import {Menu as MUIMenu, MenuProps as MUIMenuProps} from '@mui/material'
import React from 'react'

interface MenuProps extends MUIMenuProps {}

export const Menu: React.FC<MenuProps> = (props) => {
  return <MUIMenu {...props} />
}
